// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__lL6EZ","head":"ProcedureTableInfo_head__2HKXu"};